import React from 'react'
import { ToastProvider } from '@/components/ui/ToastProvider'
import ThemeInitializer from '@/components/ui/ThemeInitializer'
import Router from './Router.tsx'

export default function AppRoot() {
  return (
    <ToastProvider>
      <ThemeInitializer />
      <Router />
    </ToastProvider>
  )
}